<template>
  <div class="vc-body">
    <div class="vc-body__content">
      <p class="vc-body__text">{{ $t('message.sichernConnect.modal.body.text') }}</p>
      <p class="vc-body__text">{{ $t('message.sichernConnect.modal.bodyNoEmail.description') }}</p>
      <ul class="vc-body__list">
        <li
          v-for="(item, index) in listItems"
          :key="index"
          class="vc-body__list-item"
        >
          <span class="vc-body__bullet">
            <status-icon status="success" color="#2d2d2d" />
          </span>
          {{ $t(item) }}
        </li>
      </ul>
      <p class="vc-body__text">{{ $t('message.sichernConnect.modal.bodyConfirm.description') }}</p>
      <span class="vc-body__email-badge">{{ mail }}</span>
    </div>
    <div class="vc-body__footer">
      <v-btn
        flat
        outline
        class="vc-btn-secondary"
        color="#4f41a3"
        :disabled="isLoading"
        @click="connection.rememberMeLater()"
      >
        {{ $t('message.sichernConnect.modal.body.disagree') }}
      </v-btn>
      <v-btn
        class="vc-btn-primary white--text"
        color="deep-purple darken-3"
        :loading="isLoading"
        @click="handleSubmit"
      >
        {{ $t('message.sichernConnect.modal.body.accept') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import StatusIcon from './StatusIcon.vue'

export default {
  name: 'SichernConnectBody',
  components: { StatusIcon },
  inject: {
    connection: {
      default: function () { return { rememberMeLater: function () {}, applyLinkAccount: function () {} } }
    }
  },
  data () {
    return {
      isLoading: false,
      listItems: [
        'message.sichernConnect.modal.bodyNoEmail.list.item1',
        'message.sichernConnect.modal.bodyNoEmail.list.item2'
      ]
    }
  },
  computed: {
    mail () {
      return this.$store.state.user.mail || ''
    }
  },
  methods: {
    async handleSubmit () {
      try {
        this.isLoading = true
        await this.connection.applyLinkAccount()
      } catch (_) {
        // modal already closed by applyLinkAccount on error
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.vc-body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 330px;

  &__content {
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  &__text {
    font-size: 1rem;
    color: #171717;
    margin: 0;
  }

  &__list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  &__list-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;
  }

  &__bullet {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
  }

  &__email-badge {
    display: inline-block;
    border: 1px solid #4F41A3;
    background: #f0eef8;
    padding: 4px 8px;
    border-radius: 8px;
    font-size: 0.875rem;
  }

  &__footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 1rem;
    padding: 1.5rem;
    border-top: 1px solid #e5e7eb;
    background: white;
  }
}

.vc-btn-secondary {
  text-transform: none;
}

.vc-btn-primary {
  text-transform: none;
}
</style>
